import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';
import { ticketAtom, isIOSDeviceAtom } from 'Atoms/Ticket';
import { formattingDigitCurrency, paymentDateTime } from 'utils';
import { staticDataAtom } from 'Atoms/Common';

const useStyles = makeStyles((theme) => ({
  root: { ...theme.containerGrid, margin: '1rem' },
  marginBottomAndroid: {
    marginBottom: '9rem',
  },
  marginBottomIOS: {
    marginBottom: '2rem',
  },
  title: { ...theme.subTitle, fontSize: '25px', fontWeight: 300 },
  subTitle2: { ...theme.subTitle2, marginLeft: '1rem' },
  listItem: {
    background: 'white',
    minHeight: '55px',
    borderRadius: '1rem',
    margin: '5px 0',
    paddingLeft: '1rem',
    paddingRight: '1rem',
  },
}));
const PaymentWaitingList = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [ticket] = useAtom(ticketAtom);
  const [staticData] = useAtom(staticDataAtom);
  const [isIOSDevice] = useAtom(isIOSDeviceAtom);

  const currency = staticData?.currency;
  const amountFormatting = (amount) => {
    return formattingDigitCurrency(
      amount,
      currency?.countryCode,
      currency?.labelCode,
    );
  };

  const totalWaitingPaid = ticket?.order?.payments?.waiting?.total;

  return (
    <Grid
      container
      className={`${classes.root} ${
        !isIOSDevice ? classes.marginBottomAndroid : classes.marginBottomIOS
      }`}
    >
      <Grid item xs={12}>
        {/* <Total
          totals={amountPay}
          label={`${t('total')} ${t(':')}`}
          currency={currency}
          styles={{ bold: false }}
        /> */}
        <Typography className={classes.subTitle2}>
          {t('payment_waiting')} ({amountFormatting(totalWaitingPaid)})
        </Typography>
      </Grid>
      <Grid item xs={12}>
        {ticket.order.payments.waiting.items.map((line, i) => {
          return (
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className={classes.listItem}
              key={`line-${i}`}
            >
              <Grid item>
                <Typography display="inline" className={classes.label}>
                  {paymentDateTime(line?.date, currency?.countryCode)}
                </Typography>
                <Typography display="inline" className={classes.label}>
                  {line.label ? `(${line.label})` : ''}
                </Typography>
                <Typography display="inline" className={classes.label}>
                  {line.fromCurrentUser ? `(${t('my_payment')})` : null}
                </Typography>
              </Grid>
              <Grid item>
                <Typography display="inline" className={classes.label}>
                  {line.tips ? `(+${amountFormatting(line.tips)}) ` : ''}
                  {amountFormatting(line.amount)}
                </Typography>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

PaymentWaitingList.propTypes = {};

export default PaymentWaitingList;
